import { render, staticRenderFns } from "./CreateActivityModal.vue?vue&type=template&id=03540fd4&scoped=true"
import script from "./CreateActivityModal.vue?vue&type=script&lang=js"
export * from "./CreateActivityModal.vue?vue&type=script&lang=js"
import style0 from "./CreateActivityModal.vue?vue&type=style&index=0&id=03540fd4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03540fd4",
  null
  
)

export default component.exports